// Mount create-dialog title: keep construction sizing, replace only the noun.
import type { EntityOperationPresentation } from '@workbuddy/services/entities';
import { toEntityDialogPresentation, type EntityDialogPresentation } from '@workbuddy/ui/v2/blocks/entity.dialog/entity.dialog.contracts';

/**
 * Merges a mount `createTitle` onto the entity's create presentation.
 *
 * `EntityDialogs.open` treats `request.presentation` as a full replace, so a title-only bag
 * would drop dialog width. Returning `undefined` when the mount has no title keeps today's
 * construction presentation.
 */
export function resolveBoardCreatePresentation(args: { createTitle?: string | null; construction?: EntityOperationPresentation | null }): EntityDialogPresentation | undefined {

  const title = args.createTitle?.trim();
  if (!title) return undefined;

  const base = toEntityDialogPresentation(args.construction ?? undefined);
  return base ? { ...base, title } : { title };
}
